import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      showDetails: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Save stacktrace info
    this.setState({ errorInfo });
    // You could also send this to a remote logging endpoint here
    // Keep console logging for development visibility
    // eslint-disable-next-line no-console
    console.error("Captured error in ErrorBoundary:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = "/";
  };

  handleCopy = async () => {
    const payload = {
      href: window.location.href,
      error: this.state.error && this.state.error.toString(),
      errorInfo: this.state.errorInfo && this.state.errorInfo.componentStack,
      userAgent: navigator.userAgent,
      time: new Date().toISOString(),
    };

    const text = JSON.stringify(payload, null, 2);
    try {
      await navigator.clipboard.writeText(text);
      alert("Debug information copied to clipboard");
    } catch (e) {
      // Fallback: open in new window
      const w = window.open();
      if (w) {
        w.document.write('<pre>' + this.escapeHtml(text) + '</pre>');
        w.document.close();
      }
    }
  };

  escapeHtml = (unsafe) => {
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  toggleDetails = () => this.setState((s) => ({ showDetails: !s.showDetails }));

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20 }}>
          <h2>Something went wrong</h2>
          <p>
            We ran into an unexpected problem while displaying this page. You can
            try reloading the page or go back to the home page.
          </p>

          <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
            <button className="btn btn-primary" onClick={this.handleReload}>Reload</button>
            <button className="btn btn-secondary" onClick={this.handleHome}>Home</button>
            <button className="btn btn-outline-secondary" onClick={this.handleCopy}>Copy debug info</button>
            <button className="btn btn-link" onClick={this.toggleDetails}>
              {this.state.showDetails ? 'Hide details' : 'Show details'}
            </button>
          </div>

          {this.state.showDetails && (
            <div style={{ marginTop: 12, whiteSpace: 'pre-wrap', fontFamily: 'monospace', background: '#f7f7f7', padding: 12, borderRadius: 4 }}>
              <strong>URL:</strong> {window.location.href}
              <br />
              <strong>Error:</strong>
              <br />
              {this.state.error ? this.state.error.toString() : '—'}
              <br />
              <strong>Component stack:</strong>
              <br />
              <div>{this.state.errorInfo?.componentStack ?? '—'}</div>
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
